import React, { Fragment } from "react";
import _ from "lodash";
import PropTypes from "prop-types";

import Select from "react-select";
import AsyncSelect from "react-select/async";

import { ClearIndicator } from "./ClearIndicator.jsx";
import { DropdownIndicator } from "./DropdownIndicator.jsx";
import { loadingText, noOptionsText, selectStyles } from "./utils/select.js";

import "./styles/style.scss";

// eslint-disable-next-line react/display-name
const USelect = React.forwardRef(
  (
    {
      isAsync,
      isDisabled,
      isSearchable,
      isClearable,
      isRequired,
      size,
      label,
      options,
      placeholder,
      validationErrors,
      ...rest
    },
    ref
  ) => {
    /**
     * Вернуть класс, применяемый для размера кнопки
     *
     * @param {String} value
     * @return {String}
     */
    const getSizeClass = value => {
      const classes = {
        xxl: "select--xxl",
        xl: "select--xl",
        lg: "select--lg",
        md: "select--md",
        sm: "select--sm",
        xs: "select--xs",
      };

      return _.get(classes, value, USelect.defaultProps.size);
    };

    const classNames = ["select", getSizeClass(size), rest.className]
      .filter(name => name)
      .join(" ");

    const extraProps = {
      isSearchable: isSearchable,
      isClearable: isClearable,
      styles: selectStyles,
      noOptionsMessage: noOptionsText,
      placeholder: placeholder,
      className: classNames,
      classNamePrefix: "select",
      ref: ref,
      components: { ClearIndicator, DropdownIndicator },
      menuPlacement: "auto",
    };

    const inputProps = {
      tabIndex: -1,
      autoComplete: "off",
      style: {
        opacity: 0,
        width: "100%",
        height: 0,
        position: "absolute",
      },
      defaultValue: rest.value,
      required: isRequired,
    };

    return (
      <div className="input-container">
        {label && <div className="label-field">{label}</div>}

        {!isAsync ? (
          <Fragment>
            <Select {...rest} {...extraProps} options={options} isDisabled={isDisabled} />
            {isRequired && <input {...inputProps} />}
          </Fragment>
        ) : (
          <Fragment>
            <AsyncSelect
              {...rest}
              {...extraProps}
              loadOptions={options}
              loadingMessage={loadingText}
              isDisabled={isDisabled}
            />
            {isRequired && <input {...inputProps} />}
          </Fragment>
        )}

        {!!validationErrors.length && (
          <div className="input-errors">
            {validationErrors.map((error, index) => (
              <div key={index} className="input-errors__error">
                {error}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
);

USelect.propTypes = {
  isAsync: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isSearchable: PropTypes.bool,
  isClearable: PropTypes.bool,
  isRequired: PropTypes.bool,
  size: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  placeholder: PropTypes.string,
  validationErrors: PropTypes.array,
};

USelect.defaultProps = {
  isAsync: false,
  isDisabled: false,
  isSearchable: false,
  isClearable: false,
  isRequired: false,
  size: "xl",
  label: "",
  options: [],
  placeholder: "",
  validationErrors: [],
};

export default USelect;
